import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LanguageContext from "components/LanguageContext";
import Icon from "components/templatesComponents/Icon";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";

const Tags = (props) => {
  const { tags = [], noIcon = false, iconColor = "inherit", sx, ...others } = props;

  const { language } = useContext(LanguageContext);

  if (!Array.isArray(tags) || tags.length === 0) {
    return null;
  }

  return (
    tags.length > 0 && (
      <Grid container {...others} sx={{ alignItems: "center", ...sx }}>
        {!noIcon && (
          <Icon
            iconDSFR="bookmark-line"
            sx={{ color: iconColor, fontSize: "16px", mr: 1 }}
            title={t[language].components.tag_icon_title}
          />
        )}
        {Array.isArray(tags) &&
          tags.map((tag) => (
            <Box key={tag} component="span" sx={{ mr: 1 }}>
              <span>#{tag}</span>
            </Box>
          ))}
      </Grid>
    )
  );
};

Tags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string),
  noIcon: PropTypes.bool,
  iconColor: PropTypes.string,
  sx: PropTypes.object,
};

export default Tags;
